/**
 * Single source of truth for company facts used across the site.
 *
 * `orgNumber` and `vatNumber` are the same registration: the Swedish VAT
 * number is "SE" + the ten digits of the organisationsnummer + "01".
 *
 * NOTE: the email address and phone number are deliberately NOT here.
 * All enquiries go through the contact form, so no direct address is
 * rendered anywhere on the site or shipped in the JS bundle where scrapers
 * could harvest it. The form delivers to the real inbox via EmailJS, which
 * holds the destination address in its own template.
 */
export const COMPANY = {
  legalName: 'Fidoco AB',
  personName: 'Firat Dogan',
  orgNumber: '559387-1980',
  vatNumber: 'SE559387198001',
  hasFSkatt: true,
  location: 'Stockholm, Sweden',
  linkedIn: 'https://linkedin.com/in/firat-dogan-0a2821a7',
  instagram: 'https://www.instagram.com/fidoco.se/',

  /**
   * Live products, keyed by the `id` on the matching home.work item.
   * A case study only renders a "visit" link when its id appears here, so an
   * unlaunched product can never produce a dead link. Kept out of the locale
   * files because a URL is not translatable content.
   */
  projectUrls: {
    align: 'https://align.fidoco.se',
  } as Record<string, string | undefined>,
} as const;

export default COMPANY;
